<template>
  <div class="menu-list">
    <div v-for="menu in props.menuList" :key="menu.id" class="py-4 flex justify-between items-center gap-3">
      <p class="flex-1">{{ menu.item }}</p>
      <div class="price-section text-right w-100px">
        <p>{{ menu.discount_price }}</p>
        <p class="text-sm text-gray-80 line-through">{{ menu.original_price }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { UsecaseMenuItem } from '@/types/api'

interface Props {
  menuList: UsecaseMenuItem[]
}

const props = defineProps<Props>()
</script>
